var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { colorPalette } from '@repo/mui-config/color-palette';
var baseStyle = {
    borderRadius: '50%',
    display: 'flex',
    justifySelf: 'center',
};
export var boxStyleIconWrapper = {
    success: __assign(__assign({}, baseStyle), { color: colorPalette.success.main, backgroundColor: colorPalette.success.light }),
    error: __assign(__assign({}, baseStyle), { color: colorPalette.error.main, backgroundColor: colorPalette.error.light }),
    info: __assign(__assign({}, baseStyle), { color: colorPalette.primary.main, backgroundColor: colorPalette.cloud.light }),
};
